import AppPlatformService from '../../../services/AppPlatform/AppPlatformService';
import strings from './strings';

const localStrings = strings[AppPlatformService.getLanguage()];

const AppSharedModalService = {
  strings: localStrings,
};

export default AppSharedModalService;
